import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useSetPageTitle } from '../components/PageTitle';

/**
 * An address inside the application that matches no page. It used to redirect silently to the dashboard, which
 * made a stale bookmark or a mistyped link look as if it had worked. Dressed in the application's own colours,
 * because looking like part of the product is what says the product works and the address does not.
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  useSetPageTitle(t('notFound.title'));

  return (
    <div className="card not-found">
      {/* The application's own mark, in Kersia green. Decorative: the heading below is the page's name. */}
      <img src="/favicon.svg" alt="" aria-hidden="true" className="not-found__mark" />

      {/* Not a heading: the words below are. A screen reader gains nothing from hearing "four zero four". */}
      <p className="not-found__code" aria-hidden="true">
        404
      </p>

      <h2>{t('notFound.title')}</h2>
      <p className="hint">{t('notFound.body')}</p>

      <Link to="/" className="btn btn-primary not-found__back">
        <i className="pi pi-home me-2" aria-hidden="true" />
        {t('notFound.back')}
      </Link>
    </div>
  );
}
